import { createApi } from '@reduxjs/toolkit/query/react';
import apiBaseQuery from './axiosBaseQuery'
export const SECTOR_API_REDUCER_KEY = 'sectorsApi';


export const sectorApi = createApi({
    reducerPath: SECTOR_API_REDUCER_KEY,
    baseQuery: apiBaseQuery,
    tagTypes: ['sectors'],
    endpoints: (builder) => ({
        getAllSectors: builder.query({
            query: ({ page, q, limit }) => ({
                url: `admin/repository/sectors?page=${page}&q=${q}&limit=${limit}`
            }),
            providesTags: ['sectors']
        }),
        getSectors: builder.query({
            query: (id) => ({
                url: `admin/repository/sectors/${id}`,
            }),
            providesTags: ['sectors']
        }),
        createSectors: builder.mutation({
            query: (body) => ({
                url: `admin/repository/sectors`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['sectors']
        }),
        updateSectors: builder.mutation({
            query: ({ id, ...rest }) => ({
                url: `admin/repository/sectors/${id}`,
                method: 'PUT',
                body: rest,
            }),
            invalidatesTags: ['sectors']
        }),
    })
});

export const {
    useGetAllSectorsQuery,
    useGetSectorsQuery,
    useCreateSectorsMutation,
    useUpdateSectorsMutation,
} = sectorApi;